<template>
  <div>
    <div v-if="loading" class="text-center mt-7">
      <v-progress-circular indeterminate color="primary" size="60">
      </v-progress-circular>
    </div>
    <div v-else>
      <div class="text-right">
        <v-pagination
          v-if="pagelength > 1"
          :total-visible="4"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>
      <v-card v-if="item.productdetail" class="elevation-5 mt-4">
        <div style="position: relative" class="pa-2">
          <div
            style="font-size: 12px; position: absolute; right: 4px; top: 3px"
          >
            {{ moment(item.timestamp).format("DD/MM/YYYY HH:mm") }}
          </div>
          <v-row>
            <v-col cols="4">
              <v-img
                style="border-radius: 5px"
                aspect-ratio="1"
                :src="item.productdetail.image"
              ></v-img>
            </v-col>
            <v-col cols="8">
              <div>
                <div>{{ item.productdetail.name }}</div>
                <div
                  style="font-size: 20px; line-height: 22px"
                  class="my-1"
                  :class="`${handleGetStatus(item.status).color}--text`"
                >
                  {{ handleGetStatus(item.status).text }}
                </div>
                <div>
                  <div style="font-size: 13px">
                    {{ item.nameaddress.address }}
                    {{ item.nameaddress.postCode }} เขต{{
                      item.nameaddress.district
                    }}
                    แขวง{{ item.nameaddress.subDistrict }} จังหวัด{{
                      item.nameaddress.province
                    }}
                    <br />
                    เบอร์โทรศัพท์ {{ item.nameaddress.phoneNumber }}
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <div style="margin-top: 48px">
        <div
          class="Kanit primary pa-4 text-center white--text"
          style="font-size: 22px"
        >
          ตรวจสอบสถานะการขนส่ง
        </div>
        <div v-if="statusLogData && statusLogData.length > 0">
          <v-timeline align-top dense>
            <template v-for="(item, i) in statusLogData">
              <v-timeline-item color="primary" small :key="i">
                <v-layout wrap>
                  <v-flex
                    class="xs4"
                    style="display: flex;align-items: center;"
                  >
                    <div class="caption">
                      {{ moment(item.timestamp).format("DD/MM/YYYY HH:mm") }}
                    </div>
                  </v-flex>
                  <v-flex class="xs8">
                    <strong>{{ handleGetStatus(item.new_data).text }}</strong>
                    <div class="text-caption" v-if="item.note">
                      {{ item.note }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>
            </template>
          </v-timeline>
          <div
            class="text-center mt-9"
            v-if="
              item &&
                (item.shippingtype === 'kerry_charge' ||
                  item.shippingtype === 'Kerry Express')
            "
          >
            <v-btn
              @click="handleCheckKerryTracking(item.trackingno)"
              color="primary"
              class="ml-2"
            >
              เช็คสถานะกับ Kerry</v-btn
            >
          </div>
        </div>
        <div v-else class="pt-4 text-center">
          <span>- ไม่มีรายการสถานะขนส่ง -</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RewardAddress from "../RewardAddress.vue";
export default {
  props: ["value"],
  components: {
    RewardAddress,
  },
  data() {
    return {
      editdata: "",
      showRewardAddress: false,
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      loading: false,

      item: [],
      shippingText: {
        flash_charge: "Flash Express",
        nim_charge: "Nim Express",
        ninjavan_charge: "Ninja Van",
        jtexpress_charge: "J&T Express",
        lalamove_charge: "Lalamove",
        cjlogistics_charge: "Cj Logistics",
        nikos_charge: "Nikos Express",
        scgexpress_charge: "SCG Express",
        skootar_charge: "Skootar",
        alphaexpress_charge: "Alpha Express",
        deliveree_charge: "Deliveree",
        grab_charge: "Grab",
        lineman_charge: "Lineman",
        tnt_charge: "TNT Express",
        cod_charge: "เก็บเงินปลายทาง",
        normal_charge: "Thailand Post",
        ems_charge: "EMS",
        kerry_charge: "Kerry Express",
        bestexpress_charge: "BEST Express",
        interexpress_charge: "Inter Express",
        dhl_charge: "DHL",
        other_charge: "ขนส่งรูปแบบอื่น",
      },
      statusLogData: null,
    };
  },
  mounted() {
    if (this.value) {
      this.item = this.value;
      this.getOrderStatus();
    }
  },
  computed: {
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit);
      } else {
        return 1;
      }
    },
    moment() {
      return moment;
    },
  },
  methods: {
    handleGetStatus(status) {
      if (status == "pending") return { text: "รอการจัดส่ง", color: "orange" };
      else if (status == "waiting")
        return { text: "รอดำเนินการ", color: "grey" };
      else if (status == "shipped")
        return { text: "จัดส่งแล้ว", color: "primary" };
      else if (status == "canceled") return { text: "ยกเลิก", color: "grey" };
      else return { text: status, color: "grey" };
    },
    async getOrders() {
      const vm = this;
      try {
        const data = {
          memberId: vm.$store.state.member.memberId, // required
          limit: vm.limit,
          offset: vm.offset,
          pageid: vm.query.pageid,
        };

        vm.loading = true;
        const url = `${vm.serverUrl}toacrm/history-point-redemtion`;
        const response = await axios.get(url, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
          params: data,
        });
        vm.loading = false;

        if (response && response.data.responsecode === 200) {
          vm.historydata = response.data.data.map((el) => {
            const productdetail = JSON.parse(el.productdetail) || {};
            const nameaddress = JSON.parse(el.nameaddress) || {};

            return {
              ...el,
              productdetail,
              nameaddress,
            };
          });
        }
      } catch (error) {
        console.error(error);
        vm.loading = false;
      }
    },
    async getOrderStatus() {
      const vm = this;
      try {
        const orderId = vm.item.id;
        const data = {
          page_id: this.query.pageid,
          date_from: "2022-01-01",
          date_to: "2022-10-01",
        };
        const url = `${vm.serverUrl}toa-crm/order-status-log/${orderId}`;

        vm.loading = true;
        const response = await axios.get(url, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
          params: data,
        });
        vm.loading = false;

        if (response && response.status === 200) {
          vm.statusLogData = response.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    handleCheckKerryTracking(trackingNo) {
      window.location.href = `https://th.kerryexpress.com/en/track/?track=${trackingNo}`;
    },
  },
};
</script>

<style lang="scss" scoped></style>
